import { useCallback, useEffect, useState } from "react";
import { getMyEngagement } from "../services/resourceAllocation.service";
import type { IMyEngagementApi } from "../services/types/resourceAllocation";

const EMPTY_ENGAGEMENT: IMyEngagementApi = {
  hasIncompleteWorkHours: false,
  year: 0,
  month: 0,
  totalOrderedMinutes: 0,
  lines: [],
};

export default function useMyEngagement(year: number, month: number) {
  const [engagement, setEngagement] = useState<IMyEngagementApi>(EMPTY_ENGAGEMENT);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getMyEngagement(year, month);
      setEngagement(data);
    } finally {
      setIsLoading(false);
    }
  }, [year, month]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    engagement,
    isLoading,
    refetch: fetchData,
  };
}
